import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import { useMemo } from "react";
import { PopupHoverContainer } from "@similarweb/ui-components";
import styled from "styled-components";
import { translate } from "app/filters/i18nFilter";
import { getIndustrieById } from "../widget-types/MarketAnalysis/helpers";
import { colorsPalettes } from "@similarweb/styles";

const TooltipItem = styled.div<{ isSegment?: boolean }>`
    margin-left: ${({ isSegment }) => (isSegment ? "5px" : "0px")};
    color: ${({ isSegment }) => (isSegment ? colorsPalettes.carbon[250] : colorsPalettes.carbon[400])};
`;

const CategoryWrapper = styled.span`
    display: flex;
    align-items: center;
`;

const CategoryName = styled.p`
    padding-left: 8px;
    margin: 0;
`;

const Icon = styled.i`
    height: 15px;
`;

const MarketAnalysisSubtitle = ({ widget }: IDashboardWidgetInterface) => {
    const categoryName = useMemo(() => {
        const id = widget._widgetConfig?.properties?.filters?.category;
        const industry = getIndustrieById(id);

        return industry?.text || industry?.name;
    }, [widget._widgetConfig?.properties?.filters?.category]);

    const popupItems = () => (
        <div>
            <TooltipItem>
                {translate("dashboard.metricGallery.Website.MarketShares.industries.tooltip.placeholder")}
            </TooltipItem>
            {widget?.legendItems.map((item, index) => (
                <>
                    <TooltipItem key={index}>{item.domain}</TooltipItem>
                    <TooltipItem
                        key={index}
                        isSegment
                    >
                        {item.segmentName}
                    </TooltipItem>
                </>
            ))}
        </div>
    );

    return (
        <span className="swWidget-dashboard-subTitle u-flex-row">
            <li className="swWidget-dashboard-subTitle-item-keyword">
                <PopupHoverContainer
                    content={popupItems}
                    config={{ placement: "bottom" }}
                >
                    <CategoryWrapper>
                        <Icon className="sw-icon-custom-categories" />
                        <CategoryName>{categoryName}</CategoryName>
                    </CategoryWrapper>
                </PopupHoverContainer>
            </li>
        </span>
    );
};

export default MarketAnalysisSubtitle;
